export default {
    animated: true,
    view: {
        styles: {
            background: '#202020',
        },
    },
    data: {
        hover: {
            enabled: true
        }
    },
    tooltip: {
        enabled: true,
        styles: {
            color: '#ffffff',
            background: '#403f4c',
            borderColor: '#fff',
            borderWidth: 0,
            borderRadius: 3,
            fontSize: 12,
            padding: {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10,
            },
        },
    },
};
